import { createContext, useContext } from 'react';
import { RegisterProviderContext } from './register.types';

export const RegisterContext = createContext<RegisterProviderContext>(
    {} as RegisterProviderContext,
);

export const useRegisterContext = (): RegisterProviderContext => {
    return useContext<RegisterProviderContext>(RegisterContext);
};
